module.exports = __webpack_public_path__ + "img/foto_2.448beaa6.jpg";